<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="同步队列"
      :visible.sync="dialogVisible"
      width="80%">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects(1)">查询</el-button>
        <div style="color: red;margin-top: 10px;">手动点查询查看同步结果</div>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :label-style="{width: '100px'}">
              <el-descriptions-item label="房产信息">

              </el-descriptions-item>
              <el-descriptions-item label="同步状态">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="date.bill_type">
                    <Radio label="当前同步"></Radio>
                      <!-- <Radio label="当前队列"></Radio> -->
                      <!-- <Radio label="同步完成"></Radio> -->
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span style="margin-left: 1px;" v-if="loading_dade==1">当前队列</span>
          <span style="margin-left: 1px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="55vh">
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="name" label="项目" width="260"></el-table-column>
            <el-table-column prop="ancestor_name" label="房产详情" show-overflow-tooltip></el-table-column>
            <el-table-column prop="order_type" label="类型" width="120"></el-table-column>
            <el-table-column prop="stutes" label="状态" width="120"></el-table-column>
            <el-table-column prop="chargeitem" label="收费项目" width="200"></el-table-column>
            <el-table-column prop="startDate2" label="开始时间" width="200"></el-table-column>
            <el-table-column prop="endDate2" label="结束时间" width="200"></el-table-column>
            <el-table-column prop="date" label="添加时间" width="200"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <Page :total="total" :page-size="page" @on-change="selects" show-total />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          loading_dade:1,
          dialogVisible:false,
          tableData: [],
          total:0,
          page:12,
          date:{
            bill_type:'当前同步',
          },
          loading:false
        }
      },
      mounted(){

      },
      //事件
      methods: {
        //返回数据
        getInvo(data,house){
          this.dialogVisible = true;
          this.selects(1);
        },
        selects(e){
          this.loading_dade = 2;
          let data = {"path":e,'bill_type':this.date.bill_type}
          //分页
          this.$myhttp.post('xsc/OrderComparisonMoney/queue',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.total = backdata.data.count;
              this.tableData = backdata.data.date;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/Comparison/synchronization.vue